import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { PrimaryButton, DefaultButton } from '@bingads-webui-react/fabric-control';
import { SpinnerWithMessage, ImageShimmer, ErrorMessageBar } from '../shared-componenets';
import { VIEWS } from '../model/constants';

import { getBackgroundRemovalViewStyles } from '../styles/change-image-background-view-styles';

export const BackgroundRemovalViewUnStyled = ({
  originalImageUrl,
  imageUrlWithoutBackground,
  setActiveView,
  logger,
  i18n,
  classes,
  onClose,
  errorMessage,
}) => (
  (
    <div className={classNames(classes.backgroundRemoveView, 'background-removal-view', imageUrlWithoutBackground && 'expanded')}>
      <div className="background-change-view-content-container">
        <div className={classNames('header', imageUrlWithoutBackground && !errorMessage && 'expanded')}>
          {i18n.getString(_TL_('We’ve removed the background. You can refine the subject area to keep or remove certain subjects and objects by selecting Edit subject area.'))}
        </div>
        <div className="image-container">
          <img src={imageUrlWithoutBackground || originalImageUrl} alt="original" />
          {!imageUrlWithoutBackground && !errorMessage && <ImageShimmer className="loading-mask" />}
        </div>
      </div>
      <div className="background-change-view-actions-container">
        <ErrorMessageBar errorMessage={errorMessage} customClassName="error-message" />
        {
          !imageUrlWithoutBackground && !errorMessage &&
          <div className="remove-tip">
            <SpinnerWithMessage message={i18n.getString(_TL_('Removing the background...'))} />
          </div>
        }
        <div className={classNames('action-box', imageUrlWithoutBackground && !errorMessage && 'expanded')}>
          <DefaultButton
            iconProps={{ iconName: 'edit' }}
            className="goto-selection-view"
            onClick={() => {
              setActiveView(VIEWS.ObjectsSelection);
              logger.logTrace('Copilot change image background - removal view - go to selection button clicked');
            }}
            disabled={errorMessage !== ''}
          >
            {i18n.getString(_TL_('Edit subject area'))}
          </DefaultButton>
          <div className="right-action">
            <PrimaryButton
              className="goto-generation-view-button"
              onClick={() => {
                setActiveView(VIEWS.ImageBackgroundGeneration);
                logger.logTrace('Copilot change image background - removal view - go to generation view button clicked');
              }}
              disabled={errorMessage !== ''}
            >
              {i18n.getString(_TL_('Continue'))}
            </PrimaryButton>
            <DefaultButton
              className="cancel-button"
              appearance="secondary"
              onClick={() => {
                onClose();
                logger.logTrace('Copilot change image background - removal view - Cancel button clicked');
              }}
            >
              {i18n.getString(_TL_('Cancel'))}
            </DefaultButton>
          </div>
        </div>
      </div>
    </div>
  )
);

BackgroundRemovalViewUnStyled.propTypes = {
  originalImageUrl: PropTypes.string.isRequired,
  imageUrlWithoutBackground: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    backgroundRemoveView: PropTypes.string,
  }).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  setActiveView: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
};

BackgroundRemovalViewUnStyled.defaultProps = {
  imageUrlWithoutBackground: '',
  errorMessage: '',
};

export const BackgroundRemovalView = withDefaultStyles(BackgroundRemovalViewUnStyled, getBackgroundRemovalViewStyles);
